import {
  DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_FAIL,
  DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_PASS,
  DATA_ORCHESTRATION_MASTER_STATUS_ERROR,
  DATA_ORCHESTRATION_MASTER_STATUS_NOT_STARTED,
  DATA_ORCHESTRATION_MASTER_STATUS_PROCESSING,
  DATA_ORCHESTRATION_MASTER_STATUS_REVIEW,
} from "@/helpers/constants";

import IconFailure from "@/components/icons/IconFailure.vue";
import IconProcessing from "@/components/icons/IconProcessing.vue";
import IconSuccessRoundBig from "@/components/icons/IconSuccessRoundBig.vue";
import IconWarning from "@/components/icons/IconWarning.vue";

export const DATA_ORCHESTRATION_MASTER_STATUS_OPTIONS = {
  [DATA_ORCHESTRATION_MASTER_STATUS_NOT_STARTED]: {
    color: 15,
    icon: null,
    transitions: [],
  },
  [DATA_ORCHESTRATION_MASTER_STATUS_PROCESSING]: {
    color: 5,
    icon: IconProcessing,
    transitions: [],
  },
  [DATA_ORCHESTRATION_MASTER_STATUS_REVIEW]: {
    color: 5,
    icon: IconWarning,
    transitions: [
      DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_PASS,
      DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_FAIL,
    ],
  },
  [DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_PASS]: {
    color: 0,
    icon: IconSuccessRoundBig,
    class: "text-green-400",
    transitions: [
      DATA_ORCHESTRATION_MASTER_STATUS_REVIEW,
      DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_FAIL,
    ],
  },
  [DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_FAIL]: {
    color: 2,
    icon: IconFailure,
    class: "text-red-400",
    transitions: [
      DATA_ORCHESTRATION_MASTER_STATUS_REVIEW,
      DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_PASS,
    ],
  },
  [DATA_ORCHESTRATION_MASTER_STATUS_ERROR]: {
    color: 2,
    icon: IconFailure,
    class: "text-red-400",
    transitions: [
      DATA_ORCHESTRATION_MASTER_STATUS_REVIEW,
      DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_PASS,
      DATA_ORCHESTRATION_MASTER_STATUS_COMPLETE_FAIL,
    ],
  },
};
